module.exports = __webpack_public_path__ + "img/icon-clip-board-check.5e4b7a56.svg";